import { render, staticRenderFns } from "./EmissionReportWrapper.vue?vue&type=template&id=aca0ef72&scoped=true&"
import script from "./EmissionReportWrapper.vue?vue&type=script&lang=ts&"
export * from "./EmissionReportWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca0ef72",
  null
  
)

export default component.exports